export const services = [
  {
    id: 'swedish',
    name: 'Swedish Massage',
    description: 'Long, flowing strokes and kneading to melt away stress and ease everyday aches — pure relaxation that leaves you feeling light, restored, and rebalanced.',
    image: 'https://media.base44.com/images/public/6a9eff3bfe0abc7a676ef301/040ae3c9b_generated_8a0399bb.jpg/v1/fill/w_1024,h_1024,al_c,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/040ae3c9b_generated_8a0399bb.webp',
    prices: [
      { duration: '30 min', price: '$75' },
      { duration: '60 min', price: '$120' },
      { duration: '90 min', price: '$165' },
      { duration: '120 min', price: '$225' }
    ]
  },
  {
    id: 'lymphatic',
    name: 'Lymphatic Drainage',
    description: 'Gentle, rhythmic strokes that support the lymphatic system — reducing swelling and promoting detoxification.',
    image: 'https://media.base44.com/images/public/6a9eff3bfe0abc7a676ef301/dd7f7b5a0_generated_image.png/v1/fill/w_1024,h_1024,al_c,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/dd7f7b5a0_generated_image.webp',
    prices: [
      { duration: '30 min', price: '$85' },
      { duration: '60 min', price: '$130' },
      { duration: '90 min', price: '$175' },
      { duration: '120 min', price: '$235' }
    ]
  },
  {
    id: 'prenatal',
    name: 'Prenatal Massage',
    description: 'Safe, supported side-lying treatment through every trimester, easing hips, back, and shoulders.',
    image: 'https://media.base44.com/images/public/6a9eff3bfe0abc7a676ef301/7a137e505_generated_image.png/v1/fill/w_1024,h_1024,al_c,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/7a137e505_generated_image.webp',
    prices: [
      { duration: '30 min', price: '$75' },
      { duration: '60 min', price: '$120' },
      { duration: '90 min', price: '$165' },
      { duration: '120 min', price: '$225' }
    ]
  }
];

export const credentials = [
  { icon: 'GraduationCap', title: 'Diploma in Massage Therapy', subtitle: '1,500-hour accredited program' },
  { icon: 'ShieldCheck', title: 'Registered with the CMTO', subtitle: 'In good standing · insurance eligible' },
  { icon: 'Leaf', title: 'Evidence-informed practice', subtitle: 'Continuous continuing education' }
];

export const heroImage = 'https://media.base44.com/images/public/6a9eff3bfe0abc7a676ef301/6200da4f3_generated_c0b241db.jpg/v1/fill/w_1920,h_1200,al_c,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/6200da4f3_generated_c0b241db.webp';

export const therapistImage = 'https://media.base44.com/images/public/6a9eff3bfe0abc7a676ef301/f8519625e_IMG_1746.jpg/v1/fill/w_1024,h_1280,al_c,q_90,usm_0.66_1.00_0.01,enc_webp,quality_auto/f8519625e_IMG_1746.webp';

export const timeSlots = ['9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00'];

export const businessInfo = {
  address: {
    line1: '137 Queen St S,',
    line2: 'Mississauga, ON',
    line3: 'L5M 1K9'
  },
  locationNote: 'Inside Restore & Replenish Spa',
  phone: '226-700-8976',
  hours: [
    { day: 'Mon–Fri', time: '9:00–19:00' },
    { day: 'Sat', time: '9:00–15:00' },
    { day: 'Sun', time: 'Closed' }
  ]
};
